import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhySection from './components/WhySection';
import AboutSection from './components/AboutSection';
import { FeaturedSection, ArticlePreviewsSection, BeginnerGuide } from './components/ContentSections';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqItems } from '@/mocks/homeContent';

const SITE_URL = 'https://allchinabuy.codes';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhySection />
        <AboutSection />
        <FeaturedSection />
        <ArticlePreviewsSection />
        <BeginnerGuide />
        <SafetySection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </div>
  );
}